import React from 'react';
import SectionHeader from './zoneComponents/SectionHeader';
import NoMatchTable from './zoneComponents/NoMatchTable';
import StopIcon from './zoneComponents/StopIcon';

const ZoneDisplay1 = ({
  zones,
  itemKey,
  doc2ZoneStyle,
  doc2Visibility,
  toggleDoc2Visibility,
  handleSectionExport,
  markAllCheckboxes,
  Stop,
  showDoc2,
  noMatchTableStyle,
  theadStyle,
  tbodyStyle,
  trStyle,
  thStyle,
  tdValueStyle,
  verticalLabel,
  containsPropVal,
  tdPropStyle,
  findDocNumber,
  data,
  comparisonID,
  setDoc1Name,
  setDoc2Name,
  renderProperNote,
  renderAddNote,
  handleCheckedMatched,
  handleStayCheckedMatched,
  handleCheckboxChange,
  returnDoc2Zones,
  lastRow,
  markForExport,
  doc1Name,
  doc2Name
}) => {
  // Check if there are any line items to display
  const hasLineItems = Object.entries(zones).slice(3, 4).some(
    ([lineItems, lineItemsObject]) => Object.entries(lineItemsObject).length > 0
  );

  if (!hasLineItems) return null;

  return (
    <div
      className="redZone"
      style={{
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: '100%',
        overflowX: 'hidden',
        borderBottom: '2px solid rgb(0, 179, 181)',
        margin: '40px 0px 0px 0px',
        backgroundColor: '#ffffff',
        maxHeight: doc2Visibility[itemKey + "_red"] ? '150px' : 'unset',
        overflowY: doc2Visibility[itemKey + '_red'] ? 'hidden' : 'auto',
      }}
    >  
      <SectionHeader 
        itemKey={itemKey}
        zones={zones}
        doc2Visibility={doc2Visibility}
        toggleDoc2Visibility={toggleDoc2Visibility}
        handleSectionExport={handleSectionExport}
        markAllCheckboxes={markAllCheckboxes}
      />
      
      <StopIcon Stop={Stop} />
      
      {Object.entries(zones)
        .slice(3, 4)
        .map(([lineItems, lineItemsObject]) => (
          <div 
            style={{
              display: 'flex', 
              flexDirection: 'column', 
              overflowX: 'hidden', 
              maxHeight: showDoc2 ? '100px' : 'unset', 
              overflowY: showDoc2 ? 'hidden' : 'hidden'
            }} 
            key={lineItems}
          >
            {Object.entries(lineItemsObject).map(([key1, val1]) => (
              <NoMatchTable
                key={`zz PNM ${returnDoc2Zones(zones["Zone 1"])} vs. ${returnDoc2Zones(zones["Zone 2"])} ${key1}`}
                tableId={`zz PNM ${returnDoc2Zones(zones["Zone 1"])} vs. ${returnDoc2Zones(zones["Zone 2"])} ${key1}`}
                zones={zones}
                key1={key1}
                val1={val1}
                doc2Visibility={doc2Visibility}
                toggleDoc2Visibility={toggleDoc2Visibility}
                handleStayCheckedMatched={handleStayCheckedMatched}
                returnDoc2Zones={returnDoc2Zones}
                noMatchTableStyle={noMatchTableStyle}
                theadStyle={theadStyle}
                tbodyStyle={tbodyStyle}
                trStyle={trStyle}
                thStyle={thStyle}
                tdValueStyle={tdValueStyle}
                verticalLabel={verticalLabel}
                containsPropVal={containsPropVal}
                tdPropStyle={tdPropStyle}
                findDocNumber={findDocNumber}
                data={data}
                comparisonID={comparisonID}
                setDoc1Name={setDoc1Name}
                setDoc2Name={setDoc2Name}
                renderProperNote={renderProperNote}
                renderAddNote={renderAddNote}
                handleCheckedMatched={handleCheckedMatched}
                handleCheckboxChange={handleCheckboxChange}
                lastRow={lastRow}
                markForExport={markForExport}
                doc1Name={doc1Name}
                doc2Name={doc2Name}
              />
            ))}
          </div>
        ))}
    </div>
  );
};

export default ZoneDisplay1;
